import { render } from "./app-menu-primary.vue?vue&type=template&id=d29014f2&scoped=true"
import script from "./app-menu-primary.vue?vue&type=script&lang=js"
export * from "./app-menu-primary.vue?vue&type=script&lang=js"

import "./app-menu-primary.vue?vue&type=style&index=0&id=d29014f2&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d29014f2"]])

export default __exports__